import { lazy } from "react";
import type { RouteConfig } from "../config";
import { ROUTES } from "../paths";

const ChatPage = lazy(() =>
  import("@/pages/chat").then((m) => ({ default: m.ChatPage }))
);

const AUTHENTICATED = { access: "authenticated" as const };

export const chatRoutes: RouteConfig[] = [
  { path: ROUTES.CHAT, component: ChatPage, layout: "dashboard", permissions: AUTHENTICATED },
];
